module.exports = __webpack_public_path__ + "img/20201102-4.281bc120.jpg";